<div class="basin-blurred-background-mask">
    <div
      class="basin-gradient-blue-to-bottom load-gradient-background p-d-flex p-jc-center p-ai-center"
    >
      <basin-lottie-animation-player
        [height]="'60px'"
        [width]="'60px'"
        [path]="'/assets/StantecSpinnerWhite.json'"
        [autoplay]="true"
        [loop]="true"
      ></basin-lottie-animation-player>
    </div>
  </div>
